module.exports = __webpack_public_path__ + "static/media/revista-marzo2008.01856d22.png";